angular.module("vgresiduos").directive("disposalConfirmationAttachments", function () {
	return {
		scope: true,
		controller: "disposalConfirmationAttachmentsCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/steps/disposalConfirmationAttachments/disposalConfirmationAttachments_template.html"
	};
});
